import {useAppSelector} from "../../../stores/store.ts";
import EpgDetailsMainView from "./EpgDetailsMainView.tsx";
import EpgDetailsNextEpisodeComingView from "./EpgDetailsNextEpisodeComingView.tsx";
import Login from "../../auth/login/Login.tsx";
import {IPlayerChannel} from "../../../interfaces/IPlayerUIState.ts";
import CircleLoader from "../../loaders/CircleLoader.tsx";
import {PulseLoader} from "../../loaders/PulseLoader.tsx";

interface IProps {
    channels: IPlayerChannel[]
}

const EpgDetails = ({channels}: IProps) => {
    const epgDetails = useAppSelector(store => store.epgDetails);

    return (
        <div
            className={`w-full h-full`}
        >
            {epgDetails.selectedView === "MAIN_VIEW" &&
                <EpgDetailsMainView channels={channels}/>}
            {epgDetails.selectedView === "NEXT_EPISODE_COMING_VIEW" &&
                <EpgDetailsNextEpisodeComingView channels={channels}/>}
            {epgDetails.selectedView === "LOGIN_VIEW" &&
                <Login/>}
            {epgDetails.selectedView === "LOADING" &&
                <div className={"flex-1 flex flex-col h-full justify-center"}>
                    <PulseLoader className={"mt-0"} />
                </div>
            }
        </div>
    );
};

export default EpgDetails;